<template>
  <div>
    <div
      v-show="show1"
      class="heightPage"
      style="overflow: auto; background-color: rgb(243, 244, 248)"
    >
      <cardIndex
        :BankList="BankList"
        :ysList="ysList"
        :processList="processList"
        @confirmingBank="confirmingBank"
        @manage="manage"
        :type="1"
      >
      </cardIndex>
    </div>

    <transition name="el-zoom-in-bottom">
      <CardList v-if="show2" @noteCard="noteCard" />
    </transition>
    <transition name="el-zoom-in-bottom">
      <ssDescriptionPage v-if="show3" :bankInfoList="bankInfoList" />
    </transition>
  </div>
</template>
<script>
import cardIndex from "../../components/cardIndex.vue";
import CardList from "./CardList";
import ssDescriptionPage from "./personalDescriptionPage";
import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  components: {
    ssDescriptionPage,
    CardList,
    cardIndex,
  },
  mixins: [verifyPermissionMinix],
  data() {
    return {
      operation: "",
      addCustomerDrawerShow: false,
      drawerTitle: "",
      noticeDialogVisible: false,
      fileVisible: false,
      selectVisible: false,
      form: {},
      show3: false,
      submitLoading: false,
      rules: {},
      talentList: [],
      tipVisible: false,
      checked: false,
      checkList: {},
      checked1: false,
      checked2: false,
      checked3: false,
      show1: true,
      show2: false,
      bankInfoList: [],
      BankList: [],
      loading: false,
      CompanyDetail: "",
      userInfo: "",
      processList: [
        { num: "01", content: "选择银行" },
        { num: "02", content: "选择人员" },
        { num: "03", content: "扫码申贷或发送通知" },
        { num: "04", content: "点击通知内链接" },
        { num: "05", content: "完成贷款" },
      ],
      ysList: [
        {
          num: 1,
          title: "高通过率：",
          content: "申请绿色通道，通过率更高。",
        },
        {
          num: 2,
          title: "快速审批：",
          content: "即申请即审批，最快1分钟完成审批。",
        },
        {
          num: 3,
          title: "申请简便：",
          content: "无抵押、无担保、随借随还。",
        },
      ],
    };
  },
  mounted() {
    this.userAutoIntId = JSON.parse(
      window.localStorage.getItem("userInfo")
    ).autoIntId;
    this.CompanyAutoIntId = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).autoIntId;
    this.getBankList();
  },
  methods: {
    manage() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    confirmingBank(bankInfoList) {
      this.bankInfoList = bankInfoList;
      console.log(this.bankInfoList);
      this.show13();
    },
    show13() {
      this.show1 = !this.show1;
      this.show3 = !this.show3;
    },
    getBankList() {
      this.loading = true;

      this.$api.manage.PersonalLoanBusiness().then((res) => {
        this.loading = false;

        if (res.error === false) {
          this.BankList = res.data;
          this.BankList.forEach((item) => {
            this.$set(item, "check", false);
          });
          console.log(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirm() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    noteCard() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    myselect(item) {
      this.$set(item, "check", !item.check);
      this.bankInfoList = [];
      this.BankList.forEach((item) => {
        if (item.check) {
          this.forBank(item);
        }
      });
      this.$forceUpdate();
    },
    addbank() {
      this.bankInfoList = [];
      this.BankList.forEach((item) => {
        if (item.check) {
          this.forBank(item);
        }
      });
    },
    forBank(item) {
      this.bankInfoList.push({
        bankId: item.bankId,
        bankName: item.bankName,
        autoIntId: item.autoIntId,
        bankAutoIntId: item.bankAutoIntId,
        userAutoIntId: this.userAutoIntId,
        bankBusinessId: item.id,
        CompanyAutoIntId: this.CompanyAutoIntId,
      });
    },
    singleNot() {
      this.fileVisible = true;
      // this.importVisible = true;
    },
    addPersonnel() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员开卡";
    },
    resetForm() {},
    notifyCard() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.noticeDialogVisible = true;
    },
  },
};
</script>
<style>
.checkbox {
  zoom: 200%;
}
</style>
<style lang="less" scoped>
.tip {
  text-align: center;
  margin-top: 20px;
  color: #e6a23c;
}
.title {
  font-size: 30px;
  text-align: center;
  color: #333333;
  font-weight: normal;
  text-align: center;
}
.btnContainer {
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>